import React from 'react';
import classNames from 'classnames';
import IFilterMatchPanel from './filterMatchPanel.d';
import styles from './filterMatchPanel.scss';

function FilterMatchPanel(props: IFilterMatchPanel) {
    const { matchingFilters, nonMatchingFilters, onPanelClick, backgroundColorStyle } = props;
    const panelStyles = backgroundColorStyle ? { backgroundColor: backgroundColorStyle } : null;

    return (
        <div
            className={classNames(styles.filter_match_panel, {[styles.has_action]: !!onPanelClick})}
            data-testid={onPanelClick ? 'filter_match_panel_action' : 'filter_match_panel_no_action'}
            onClick={onPanelClick}
            style={panelStyles}
        >
            <div className={styles.filters}>
                <svg className={styles.plus_icon} xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                     viewBox="0 0 28 28">
                    <g>
                        <circle cx="14" cy="14" r="14"/>
                    </g>
                    <path d={'M19.09062,13.0996H14.90019V8.90917a.90039.90039,0,0,0-1.80078,0V13.0996H8.909a.' +
                        '90039.90039,0,0,0,0,1.80078h4.19043v4.19043a.90039.90039,0,1,0,1.80078,0V14.90038h4.' +
                        '19043a.90039.90039,0,0,0,0-1.80078Z'}/>
                </svg>
                <span>{matchingFilters.length}</span>
            </div>
            <div className={styles.filters}>
                <svg className={styles.minus_icon} xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                     viewBox="0 0 28 28">
                    <g>
                        <circle cx="14" cy="14" r="14"/>
                    </g>
                    <path d={'M19.09082,14.90049H8.90918a.90039.90039,0,0,1,0-1.80078H19.09082a.90039.90039,' +
                        '0,0,1,0,1.80078Z'}/>
                </svg>
                <span>{nonMatchingFilters.length}</span>
            </div>
            {!!onPanelClick &&
                <div className={styles.expand_arrow}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="20px" height="20px">
                        {/* eslint-disable-next-line max-len */}
                        <path d="M19.99976,30.90058a.90014.90014,0,0,1-.65771-1.51465l6.42676-6.88574-6.42676-6.88575a.89994.89994,0,1,1,1.31543-1.22851l7,7.5a.90039.90039,0,0,1,0,1.22851l-7,7.5A.89779.89779,0,0,1,19.99976,30.90058Z"/>
                    </svg>
                </div>
            }

        </div>
    );
}

export default FilterMatchPanel;

